import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getResources () {
  apiConsolelog('api: getResources()')

  return request({
    url: '/web-resources/list',
    method: 'get'
  })
}

export function downloadResource (id) {
  apiConsolelog('api: downloadResource(): id = %s', id)

  return request({
    url: '/web-resources/' + id + '/download',
    method: 'get'
  })
}
